import React from 'react';
import { Package, DollarSign, TrendingUp, ShoppingCart } from 'lucide-react';

export default function StatsCards({ products, categories }) {
  const totalProducts = products.length;
  const totalValue = products.reduce((sum, p) => sum + (p.price * p.stock), 0);
  const lowStock = products.filter(p => p.stock < 10).length;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Total Products</p>
            <p className="text-3xl font-bold text-gray-900">{totalProducts}</p>
          </div>
          <Package className="text-blue-500" size={40} />
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Inventory Value</p>
            <p className="text-3xl font-bold text-gray-900">${totalValue.toFixed(0)}</p>
          </div>
          <DollarSign className="text-green-500" size={40} />
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Low Stock Items</p>
            <p className="text-3xl font-bold text-gray-900">{lowStock}</p>
          </div>
          <TrendingUp className="text-yellow-500" size={40} />
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Categories</p>
            <p className="text-3xl font-bold text-gray-900">{categories.length}</p>
          </div>
          <ShoppingCart className="text-red-500" size={40} />
        </div>
      </div>
    </div>
  );
}